import React, { useState } from 'react'
import Select from "react-select"
import { Dropdown, Menu, Select as AntSelect } from 'antd'
import { useParams } from 'react-router-dom'

import { AiOutlineDown } from 'react-icons/ai'

import { stringifyDate, useListData, usePet, useToggle } from '../modules'

import Receive from '../components/resusable/receive'
import NewTable from '../components/modals/newTable'
import Confirm from '../components/resusable/confirm'
import Table from '../components/modals/table'

const { Option } = AntSelect

const Tables = () => {
    const [string, setString] = useState('')
    const [selected, setSelected] = useState()

    const [tableModal, toggleTableModal] = useToggle()
    const [newTableModal, toggleNewTableModal] = useToggle()

    const [
        { loading, error, fetch }, 
        { list: tables }, 
        { navigate, Paginate, page, limit }
    ] = useListData('tables', {
        string
    }, { notify: true })
    
    const viewTable = itm => {
        setSelected(itm)
        toggleTableModal()
    }
    
    const refetch = () => {
        navigate(1)
        fetch()
    }
    
    const search = str => {
        setString(str)
        if (str?.trim().length > 2 || str.length === 0)
            refetch()
    }

    const [, deleteTable] = usePet('deleteTable', {
        id: selected?._id
    }, { notify: true, callback: (_, notif, ops) => {
        notif("Table has been deleted", ops('success'))
        refetch()
    }, manual: true })
    
    const deleteTbl = itm => {
        setSelected(itm)
        Confirm({
            title: 'Delete table?',
            message: 'Please note that this action is not reversable',
            okText: 'Delete Table',
            onOk: deleteTable
        })
    }

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
            {
                newTableModal &&
                <NewTable
                    onComplete={ refetch }
                    toggle={toggleNewTableModal}
                    visible={newTableModal} />
            }
            {
                tableModal &&
                <Table
                    table={ selected }
                    onComplete={ refetch }
                    toggle={toggleTableModal}
                    visible={tableModal} />
            }
            <div className="sm:flex sm:justify-between sm:items-center mb-8">
                {/* <ul className="flex flex-wrap justify-center sm:justify-start mb-8 sm:mb-0 -space-x-3 -ml-px" /> */}
                <input
                    onChange={e => search(e.target.value)}
                    className="appearance-none block max-w-4xl bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                    id="grid-inv-item"
                    type="text"
                    placeholder="Search Tables" />
                <div className="grid grid-flow-col sm:auto-cols-max justify-start sm:justify-end gap-2">
                    <button onClick={toggleNewTableModal} className="btn hisani-btn-green text-white">
                        <svg className="w-4 h-4 fill-current opacity-50 flex-shrink-0" viewBox="0 0 16 16">
                            <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                        </svg>
                        <span className="hidden xs:block ml-2">New Table</span>
                    </button>
                </div>
            </div>
            <div className="col-span-full xl:col-span-8 bg-white shadow-lg rounded-sm border border-gray-200">
                <header className="px-5 py-4 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="font-semibold text-gray-800">Tables</h2>
                </header>
                <div className="p-3">
                    <div className="overflow-x-auto">
                        <Receive
                            error={error}
                            loading={loading}
                            progress>
                            {
                                tables.length > 0 ?
                                    <table className="table-auto w-full">
                                        {/* Table header */}
                                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                            <tr>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">No</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-left">Table</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Capacity</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center">Added On</div>
                                                </th>
                                                <th className="p-2">
                                                    <div className="font-semibold text-center"></div>
                                                </th>
                                            </tr>
                                        </thead>
                                        {/* Table body */}
                                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                                            {
                                                tables.map((table, key) =>
                                                    <tr>
                                                        <td className="p-2">
                                                            <div className="text-center">{ ((page - 1) * limit) + (key + 1) }.</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="">{table.name}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{table.capacity}</div>
                                                        </td>
                                                        <td className="p-2">
                                                            <div className="text-center">{ stringifyDate(table.date) }</div>
                                                        </td>
                                                        <td className="p-2 text-center">
                                                            <Dropdown
                                                                overlay={
                                                                    <Menu>
                                                                        <Menu.Item onClick={ () => viewTable(table) }>View</Menu.Item>
                                                                        <Menu.Item onClick={ () => deleteTbl(table) }>Delete Table</Menu.Item>
                                                                    </Menu>
                                                                }>
                                                                <a className="ant-dropdown-link flex items-center h-10" onClick={e => e.preventDefault()}><span className="mr-2">Actions</span> <AiOutlineDown /></a>
                                                            </Dropdown>
                                                        </td>
                                                    </tr>
                                                )
                                            }
                                        </tbody>
                                    </table>
                                :
                                    <div className="flex font-semibold text-md justify-center items-center">
                                        <h2>Please click above to add tables</h2>
                                    </div>
                            }
                        </Receive>
                        {Paginate}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Tables